import React from 'react'
import FadeIn from 'react-fade-in';
import { Button, Card, CardBody, CardText, CardTitle } from 'reactstrap';
import './styles/estilo.css'
//import { tela_fluxo } from '../telas_id';
//import Loading from '../components/Loading'

import {CardInfo, BoxInfo} from './styles/estilo_telas'

import {ApresentacaoText} from './text/comprovate.text'

import { status, situacao } from '../components/Info';

import { PropTelaRes } from '../ts/interfaces/PropTelas.interfaces';
import { Base64Type } from '../ts/types/Types';
import { updateInfoBPO } from '../state/actions/Info_actions';
import FormAddress from '../forms/FormAddress';
import { getStateJornada, setStateJornada } from '../state/actions/jornada_actions';

const tela = {
  apresentacao: 0,
  opcao: 1
}

interface State {
  data: Base64Type,
  datab64: Base64Type,
  dataUrl: string | null,
  step: number
}

const {REACT_APP_PERFIL} = process.env

export default class ResidenciaNovo extends React.Component<PropTelaRes, State> {
  constructor(props : PropTelaRes){
    super(props)
    this.Aceitar = this.Aceitar.bind(this);
    this.Apresentacao = this.Apresentacao.bind(this)
    this.Opcao = this.Opcao.bind(this)
    this.ProximoPasso = this.ProximoPasso.bind(this)
    
    
    this.state = {
      data: null,
      datab64: null,
      dataUrl: null,
      step: tela.apresentacao,
      
    }
    
    
    
  }
  
  handleSubmit = (cep : string, uf : string, cidade : string, endereco : string) => {
    console.log('chamou');
    setStateJornada({endereco_comprovante: {cep, uf, cidade, endereco}})
    const ads = getStateJornada();
    //this.props.history.push('/')
    console.log(`endereço:\n ${ads.endereco_comprovante.cidade}\n ${ads.endereco_comprovante.endereco}\n ${ads.endereco_comprovante.uf}\n ${ads.endereco_comprovante.cep}`)
    this.props.changePasso();
  }

  Aceitar() {
    //updateInfoBPO({fase: status.lgpd_aceita, situacao: situacao.sucesso});
    //addInfo(tela_fluxo.validacao);
    this.props.changePasso();
  }
  
  componentDidMount(){
    updateInfoBPO({fase: status.tela_comprovante_residencia, situacao: situacao.sucesso});
    //addInfo(tela_fluxo.documento_residencia);
  }



  Apresentacao(){
    return(
      <FadeIn>
          <BoxInfo>
            <Card
              body
              className="text-center"
            >
              <CardTitle tag="h5">
                {ApresentacaoText.title1}
              </CardTitle>
              <CardText>
                {ApresentacaoText.text1}
              </CardText>
            </Card>
            {/*<Banner src={comprovante} alt='intro-comprovante' />
            {ApresentacaoText.text2}*/}
            <Button block={true} id={REACT_APP_PERFIL == 'BPO'?'button-bpo':'button-purple'} onClick={()=> this.setState({step: tela.opcao})}> Seguir </Button>
          </BoxInfo>
      </FadeIn>
    );
  }



  Opcao(){
    
    return(
      <FadeIn>
        <CardInfo>
          <Card body>
            <CardBody>
              <h6 className="text-left"><b>Declaração de Residência:</b></h6>
              <FormAddress handleSubmit={this.handleSubmit} history={undefined} enviado={false}/>
              {/*<FormAddress handleSubmit={function (cep: string, uf: string, city: string, street: string, number: string): void {
                setStateJornada({endereco: {cep, uf, city, street}})
                throw new Error('Function not implemented.');
              } } history={undefined}/>*/}
            </CardBody>
          </Card>
        </CardInfo>
      </FadeIn>
    );
  }


  ProximoPasso(){
    this.props.changePasso()
  }



  render(){
    const {step} = this.state;

    switch(step){
      case tela.apresentacao:
        return(this.Apresentacao());
        case tela.opcao:
          return(this.Opcao());
      default:
        break;
    }
    return null;
  }
  
}